import * as account from './account';
import * as form from '../containers/FormMessage';
import * as loginConsents from '../containers/loginConsents';
import * as notifications from '../containers/layout/Notifications';
import * as omniLink from '../containers/omniLink';
import * as settings from '../containers/settings';
import * as transfer from '../containers/transfer';
import * as withOmni from '../containers/withOmni';
import * as withdraw from '../containers/withdraw';
import app from './app';
import auth from './auth';
import bettingBuddy from '../containers/bettingBuddy';
import cashInPrices from './cashInPrices';
import cimb from './cimb';
import cms from './cms';
import contentStack from './contentStack';
import events from './events';
import freeBets from './freeBets';
import i18n from '../containers/i18n';
import liveScores from '../containers/liveScores';
import modal from './modal';
import openBets from '../containers/openBets';
import registration from '../containers/registration';
import settledBets from '../containers/settledBets';
import slip from './slip';
import user from './user';
import contentApi from './contentApi';

export const reducers = {
  account: account.reducer,
  app: app.reducer,
  auth: auth.reducer,
  bettingBuddy: bettingBuddy.reducer,
  cashInPrices: cashInPrices.reducer,
  cimb: cimb.reducer,
  cms: cms.reducer,
  contentStack: contentStack.reducer,
  contentApi: contentApi.reducer,
  events: events.reducer,
  form: form.reducer,
  freeBets: freeBets.reducer,
  i18n: i18n.reducer,
  liveScores: liveScores.reducer,
  modal: modal.reducer,
  notifications: notifications.reducer,
  omniLink: omniLink.reducer,
  openBets: openBets.reducer,
  registration: registration.reducer,
  settings: settings.reducer,
  settledBets: settledBets.reducer,
  slip: slip.reducer,
  transfer: transfer.reducer,
  user: user.reducer,
  withdraw: withdraw.reducer,
};

export const sagas = [
  account.saga,
  app.saga,
  auth.saga,
  bettingBuddy.saga,
  cashInPrices.saga,
  form.saga,
  freeBets.saga,
  liveScores.saga,
  loginConsents.saga,
  notifications.saga,
  omniLink.saga,
  openBets.saga,
  registration.saga,
  settings.saga,
  settledBets.saga,
  slip.saga,
  transfer.saga,
  user.saga,
  withOmni.saga,
  withdraw.saga,
];
